export enum ProviderEnum {
  CASINO = 'casino',
  GAMING = 'gaming',
  SPORT = 'sport-book',
  SPORTSBOOK = 'sportsbook',
  LOTTO = 'lotto',
}
